import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeaderWithoutLang from '../HeaderWithoutLang';
import showToast from '../../utility/showToast';
import Footer from '../Footer';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../../hooks/usePageTitle';
import getClientInfo from '../../utility/getClientInfo';
import { CREDIT_API_URL } from '../../constants';
import useUtmStore from '../../store/useUtmStore';

const BusinessListingProductDetails = () => {
    const { t } = useTranslation(['homepage']);
    const { businessName } = useParams();
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        isConsentAccepted:true
    });
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [mainImage, setMainImage] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const utm = useUtmStore(state => state.utm || {});
    const { browserName, deviceType, userAgent } = getClientInfo();
    usePageTitle('Greenway Mobility - Electric Vehicles - GrowBizh');

    // Helper to convert slug to Title Case words
    const toTitleCase = (str) => {
        return str
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Product data with detailed specifications
    const products = [
        {
            id: 1,
            name: 'CHHOTA OTTO',
            description: 'Swift. Safe. Sustainable. That is our Chhota Otto, an electric rickshaw made with independent suspension to lower toppling risk, adjustable seats & super-fast charging. This electric auto rickshaw is India\'s companion to travel into the future!',
            image: '/images/chotta-otto.png',
            features: [
                'Super-Fast Charging',
                'Made for Indian Roads',
                'Low Maintenance',
                'Swift Performance',
                '100% Electric & Eco-Friendly'
            ],
            specifications: {
                'Overall Length': '2766 mm',
                'Overall Width': '990 mm',
                'Overall Height': '1720 mm',
                'Ground Clearance': '260 mm',
                'Tyre Size (Ralco)': 'R12',
                'Wheel Trake': '890 mm',
                'Battery & Capacity': 'Robust Lithium Iron Battery 48V\nLasts 4 hours\nFixed & Swappable (5.04 kW)\nFast Charging in 2.5 hours',
                'Max Speed': '25 Km/h',
                'Range': '80 - 100 Km',
                'Payload Capacity': '400 Kgs'
            },
            additionalFeatures: [
                { text: 'Independent Suspension for Safety', icon: '/images/safety.svg' },
                { text: 'Exclusive Anti-Topple Design', icon: '/images/Anti-Topple.svg' },
                { text: 'Lesser Maintenance', icon: '/images/lesser.svg' },
                { text: 'Fixed & Swappable Battery (5.04 kW | 8.8 kW)', icon: '/images/battery.svg' },
                { text: '100-150 km Ideal City Range', icon: '/images/range.svg' }
            ],
            galleryImages: [
                '/images/chotta-otto.png',
                '/images/chotta-otto-2.png',
                '/images/chotta-otto-3.png'
            ]
        },
        {
            id: 2,
            name: 'CHHOTA BULL',
            description: 'Built to withstand the toughest conditions, Chhota Bull delivers long-lasting performance achieving 100 kms on a single charge with a 400 kg payload capacity, 260 mm ground clearance, and a cargo space of 990×1420mm. This powerful cargo e-rickshaw is ready to charge through any challenge!',
            image: '/images/chotta-bull.png',
            features: [
                'Electric & Cost-Efficient',
                '400kg Payload Capacity',
                'Ready for All Terrains',
                '100km Range Per Charge',
                '260mm Ground Clearance'
            ],
            specifications: {
                'Overall Length': '2800 mm',
                'Overall Width': '1420 mm',
                'Overall Height': '1800 mm',
                'Ground Clearance': '260 mm',
                'Tyre Size (Ralco)': 'R12',
                'Wheel Trake': '1200 mm',
                'Battery & Capacity': 'Robust Lithium Iron Battery 48V\nLasts 6 hours\nFixed & Swappable (7.2 kW)\nFast Charging in 3 hours',
                'Max Speed': '25 Km/h',
                'Range': '100 - 120 Km',
                'Payload Capacity': '400 Kgs'
            },
            additionalFeatures: [
                { text: 'Heavy Duty Performance', icon: '/images/safety.svg' },
                { text: 'All Terrain Ready', icon: '/images/Anti-Topple.svg' },
                { text: 'Large Cargo Space', icon: '/images/lesser.svg' },
                { text: 'Robust Build Quality', icon: '/images/battery.svg' },
                { text: 'Extended Range Performance', icon: '/images/range.svg' }
            ],
            galleryImages: [
                '/images/chotta-bull-1.png',
                '/images/chotta-bull-2.png',
                '/images/chotta-bull-3.png'
            ]
        },
        {
            id: 3,
            name: 'RYDAN',
            description: 'Robust at core. Comfort at peak. Rydan is our electric rickshaw with 18% gradability, a 100-150km range and a power-packed battery with 15 min charging- making it the companion of every journey.',
            image: '/images/rydan.png',
            features: [
                'Super-Fast Charging',
                'Made for Indian Roads',
                'Low Maintenance',
                'Perfect for Daily Commutes',
                'Designed for Peak Comfort'
            ],
            specifications: {
                'Overall Length': '2750 mm',
                'Overall Width': '1000 mm',
                'Overall Height': '1700 mm',
                'Ground Clearance': '250 mm',
                'Tyre Size (Ralco)': 'R12',
                'Wheel Trake': '900 mm',
                'Battery & Capacity': 'Robust Lithium Iron Battery 48V\nLasts 5 hours\nFixed & Swappable (6.0 kW)\nFast Charging in 15 minutes',
                'Max Speed': '25 Km/h',
                'Range': '100 - 150 Km',
                'Payload Capacity': '350 Kgs'
            },
            additionalFeatures: [
                { text: '18% Gradability', icon: '/images/safety.svg' },
                { text: 'Ultra-Fast 15 Min Charging', icon: '/images/Anti-Topple.svg' },
                { text: 'Premium Comfort Design', icon: '/images/lesser.svg' },
                { text: 'Extended Range Performance', icon: '/images/range.svg' },
                { text: 'Ideal for City Commutes', icon: '/images/battery.svg' }
            ],
            galleryImages: [
                '/images/rydan.png',
                '/images/rydan.png',
                '/images/rydan.png'
            ]
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // For mobile field, only allow numbers and limit to 10 digits
        if (name === 'mobile') {
            const numericValue = value.replace(/\D/g, ''); // Remove non-digits
            if (numericValue.length <= 10) {
                setFormData(prev => ({
                    ...prev,
                    [name]: numericValue
                }));
            }
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isFormValid || isSubmitting) return;

        setIsSubmitting(true);

        const humanBusinessName = toTitleCase(businessName);

        const payload = {
            name: formData.name,
            mobile: Number(formData.mobile),
            email: formData.email,
            productType: `Enquiry - ${humanBusinessName}`,
            businessName: humanBusinessName,
            utmCampaign: utm.utmCampaign || "GrowBizh",
            utmSource: utm.utmSource || null,
            utmMedium: utm.utmMedium || null,
            browserName: browserName || null,
            deviceType: deviceType || null,
        };

        try {
            const response = await fetch(`${CREDIT_API_URL}create-lead`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            // Accept 200 OK, 400 Bad Request (validation), or 409 Conflict (existing lead) as handled responses
            if ([200, 400, 409].includes(response.status)) {
                // reset form on handled response
                setFormData({ name: '', mobile: '', email: '' });

                if (result?.data?.isExistingLead) {
                    showToast('We already have your enquiry for this product! Our team will contact you soon.', 'info');
                } else {
                    showToast('Thank you for your enquiry! Our team will contact you shortly.', 'success');
                }
            } else {
                throw new Error(result.message || `API error: ${response.status}`);
            }
        } catch (error) {
            console.error('Lead creation failed', error);
            showToast('Something went wrong. Please try again later.', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Check if all required fields are filled and mobile is 10 digits
    const isFormValid = formData.name.trim() !== '' && 
                       formData.mobile.trim() !== '' && 
                       /^\d{10}$/.test(formData.mobile.trim());

    const openModal = (product) => {
        setSelectedProduct(product);
        setMainImage(product.image);
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
        document.body.style.overflow = 'unset';
    };

    return (
        <>
            <HeaderWithoutLang />
            
            {/* Hero Section */}
            <section className="greenway-hero">
                <div className="section-container">
                    <div className="greenway-hero-content">
                        <h1 className="greenway-title">Greenway Mobility</h1>
                        <p className="greenway-subtitle">Naye Daur Ka Mazboot Saathi, Made for the electric future.</p>
                        
                        <div className="greenway-hero-form form-horizontal">
                            <div className="hero-form-row">
                                <div className="floating-input-group">
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        className="floating-input"
                                        id="name"
                                        placeholder=" "
                                    />
                                    <label htmlFor="name" className="floating-label">Enter Name</label>
                                </div>
                                <div className="floating-input-group">
                                    <input
                                        type="tel"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        required
                                        className="floating-input"
                                        id="mobile"
                                        placeholder=" "
                                        maxLength="10"
                                        pattern="[0-9]{10}"
                                        inputMode="numeric"
                                    />
                                    <label htmlFor="mobile" className="floating-label">Enter Mobile Number</label>
                                </div>
                                <div className="floating-input-group">
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="floating-input"
                                        id="email"
                                        placeholder=" "
                                    />
                                    <label htmlFor="email" className="floating-label">Enter Email Id (optional)</label>
                                </div>
                            </div>
                            <button 
                                type="submit" 
                                className={`hero-enquire-btn ${(!isFormValid || isSubmitting) ? 'disabled' : ''}`}
                                onClick={handleSubmit}
                                disabled={!isFormValid || isSubmitting}
                            >
                                {isSubmitting ? 'Please wait...' : 'Enquire Now'}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Product Details Section */}
            <section className="product-details-section">
                <div className="section-container">
                    <h2 className="section-title">Check Out Product Details</h2>
                    
                        <div className="products-list">
                        {products.map((product) => (
                                <div key={product.id} className="product-card">
                                    <div className="product-image">
                                    <img src={product.image} alt={product.name} />
                                    </div>
                                    <div className="product-info">
                                    <h3 className="product-name">{product.name}</h3>
                                        <p className="product-description">{product.description}</p>
                                        
                                        <div className="product-features">
                                        {product.features.map((feature, index) => (
                                                <span key={index} className="feature-tag">
                                                    {feature}
                                                </span>
                                            ))}
                                        </div>
                                        
                                        <button 
                                            className="know-more-btn"
                                            onClick={() => openModal(product)}
                                        >
                                            Know More →
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    
                    {/* <div className="view-all-container">
                        <button className="view-all-products-btn">View All</button>
                    </div> */}
                </div>
            </section>

            {/* Product Detail Modal */}
            {isModalOpen && selectedProduct && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Product Details :</h2>
                            <button className="modal-close" onClick={closeModal}>×</button>
                        </div>
                        
                        <div className="modal-body">
                            <div className="modal-product-section">
                                <div className="modal-product-gallery">
                                    <div className="main-image">
                                        <img src={mainImage} alt={selectedProduct.name} />
                                    </div>
                                        <div className="thumbnail-images">
                                        {selectedProduct.galleryImages.map((img, index) => (
                                                <img
                                                    key={index}
                                                    src={img}
                                                alt={`${selectedProduct.name} ${index + 1}`}
                                                    onClick={() => setMainImage(img)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            ))}
                                    </div>
                                    
                                    <div className="modal-features">
                                        {selectedProduct.features.map((feature, index) => (
                                            <span key={index} className="modal-feature-tag">
                                                {feature}
                                            </span>
                                        ))}
                                    </div>
                                    
                                    <div className="modal-additional-features">
                                        {selectedProduct.additionalFeatures.map((feature, index) => (
                                            <div key={index} className="additional-feature-item">
                                                <img src={feature.icon} alt={feature.text} className="feature-icon" />
                                                <span className="feature-text">{feature.text}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className="modal-product-info">
                                    <h3 className="modal-product-name">{selectedProduct.name}</h3>
                                    <p className="modal-product-description">{selectedProduct.description}</p>
                                    
                                        <div className="specifications-section">
                                            <h3 className="specs-title">Specifications</h3>
                                            <div className="specs-table">
                                                {Object.entries(selectedProduct.specifications).map(([key, value]) => (
                                                    <div key={key} className="spec-row">
                                                        <div className="spec-label">{key}</div>
                                                        <div className="spec-value">
                                                        {value.split('\n').map((line, index) => (
                                                                <div key={index}>{line}</div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            
                                            <div className="modal-actions">
                                                <button className="download-spec-btn">
                                                    📄 Download Spec Sheet
                                                </button>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default BusinessListingProductDetails;
